<ul class="tabs switches" [class.theme1]="theme === 'theme1'" [class.theme2]="theme === 'theme2'">
    <li class="tab switch" *ngFor="let panel of panels; let i = index" [class.step]="panel.step"
        [class.disabled]="panel.disabled" (click)="activateTab(panel)" [class.active]="panel.active"
        [class.on]="theme === 'theme2' && activePanel>=i">
        <span class="panelcounter" *ngIf="counterActive">
            {{i+1}}
        </span>
        <span class="paneltitle">
            <ng-container *ngTemplateOutlet="panel.label2"></ng-container>
            <ng-container *ngIf="panel.label">{{panel.label}}</ng-container>
        </span>
        <span class="deco"></span>
    </li>
</ul>
<div class="panels-wrapper">
    <div class="panel-container">
        <div *ngFor="let panel of panels" [attr.id]="panel.id" class="panel" [class.autoheight]="autoHeight"
            [class.panel-active]="panel.active">
            <ng-container *ngIf="panel.active">
                <div class="template-container" *ngTemplateOutlet="panel.content"></div>
            </ng-container>
        </div>
    </div>
</div>